import { LocalizedTextDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/localized-text-display-model';
import { AnfrageListDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-list-display-model';
import { PortalkonfigurationDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { Component, inject, OnInit, Type } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { I18nService } from '@/core/services/i18nService';
import { EnumValue } from '@/core/models/enumvalue.model';
import { AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode, AnfrageDisplayModel, GlobalEnumerationsAceAnzeigestatusportal } from '@/api/model-index';
import { AnfrageListFactory } from '@/core/factories/anfrage-list.factory';
import { ComponentService } from '@/core/services/component.service';
import { AnfrageCardComponent } from '../anfrage-card/anfrage-card.component';

@Component({
    selector: 'anfrage-overview',
    templateUrl: './anfrage-overview.component.html',
    styleUrls: ['./anfrage-overview.component.scss'],
    standalone: false
})
export class AnfrageOverviewComponent implements OnInit {
    public portalkonfiguration: PortalkonfigurationDisplayModel;
    public anfragen: AnfrageListDisplayModel[];
    public unfilteredAnfragen: AnfrageListDisplayModel[];
    public sortSelection: any;
    public sortSelectionListEnums: EnumValue[] = [
        { Value: 1, Name: 'Antragsdatum', Description: 'Antragsdatum' },
        { Value: 2, Name: 'Name', Description: 'Name' },
        { Value: 3, Name: 'Antragsnummer', Description: 'Antragsnummer' },
    ]
    public filterTitles: string = '';

    constructor(protected router: Router, protected route: ActivatedRoute, protected languageservice: I18nService, protected anfrageListFactory: AnfrageListFactory) {
        //
    }

    protected componentService = inject(ComponentService);

    public get anfrageCardComponent(): Type<AnfrageCardComponent> {
        return this.componentService.get(AnfrageCardComponent);
    }

    ngOnInit(): void {
        this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;
        this.unfilteredAnfragen = this.route.snapshot.data.anfragen;
        this.sortSelection = this.sortSelectionList[0].Value;
        this.anfragen = this.getAnfragenList();
    }

    public get showList(): boolean {
        return this.unfilteredAnfragen?.length > 0;
    }

    public get title(): string {
        let title: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.willkommenstexte);
        return title?.text ?? "";
    }

    public get subtitle(): string {
        let subtitle: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.infotexteMeineProjektideen)
        return subtitle?.text ?? "";
    }

    public onAnfrageDelete = (anfrage: AnfrageListDisplayModel) => {
        this.anfragen = this.anfragen.filter(a => a !== anfrage);
    };

    public get sortSelectionList(): EnumValue[] {
        let sortList = this.sortSelectionListEnums;
        sortList.forEach((sort: EnumValue) => sort.Description = this.languageservice.instantEnum("Enum.AnfrageSort." + sort.Name, sort.Value));
        return sortList;
    }

    public onSortSelectionChange(value: any) {
        if (value != null && value != undefined && value != "") {
            this.sortSelection = value;
            this.anfragen = this.getAnfragenList();
        }
    }

    onfilterTitlesChange(filter: string) {
        this.filterTitles = filter;
        this.anfragen = this.getAnfragenList();
    }

    public getAnfragenList(): AnfrageListDisplayModel[] {
        this.anfragen = this.unfilteredAnfragen;
        this.anfragen = this.anfragen.filter((anfrage: AnfrageListDisplayModel) => {
            if (this.filterTitles == null || this.filterTitles == "") {
                return true;
            }
            if (anfrage.name?.toLocaleLowerCase().includes(this.filterTitles.toLocaleLowerCase())
                || anfrage.nummer?.toLocaleLowerCase().includes(this.filterTitles.toLocaleLowerCase())) {
                return true;
            }
            return false;
        });
        if (this.sortSelection == 1) {
            this.anfragen.sort((a, b) => this.sortAnfragenByAntragsdatum(a, b));
        }
        else if (this.sortSelection == 2) {
            this.anfragen.sort((a, b) => this.sortAnfragenByName(a, b));
        }
        else if (this.sortSelection == 3) {
            this.anfragen.sort((a, b) => this.sortAnfragenByAntragsnummer(a, b));
        }
        return this.anfragen;
    }

    public sortAnfragenByName(a: AnfrageListDisplayModel, b: AnfrageListDisplayModel): number {
        if (a.name == null && a.antragsdatum != null && b.name == null && b.antragsdatum != null)
            return this.sortAnfragenByAntragsdatum(a, b);
        if (a.name == null && a.antragsdatum == null && a.nummer != null && b.name == null && b.antragsdatum == null && b.nummer != null)
            return this.sortAnfragenByAntragsnummer(a, b);
        if (a.name == null && b.name == null)
            return 0;
        if (a.name == null)
            return 1;
        if (b.name == null)
            return -1;
        if (a.name < b.name)
            return -1;
        if (a.name > b.name)
            return 1;
        return 0;
    }

    public sortAnfragenByAntragsnummer(a: AnfrageListDisplayModel, b: AnfrageListDisplayModel): number {
        if (a.nummer == null && b.nummer == null) {
            return 0;
        } else if (a.nummer == null) {
            return 1;
        } else if (b.nummer == null) {
            return -1;
        } else if (a.nummer < b.nummer) {
            return -1;
        } else if (a.nummer > b.nummer) {
            return 1;
        } else {
            return 0;
        }
    }

    public sortAnfragenByAntragsdatum(a: AnfrageListDisplayModel, b: AnfrageListDisplayModel): number {
        if (a.antragsdatum == null && b.antragsdatum == null) {
            return 0;
        } else if (a.antragsdatum == null) {
            return 1;
        } else if (b.antragsdatum == null) {
            return -1;
        } else if (a.antragsdatum > b.antragsdatum) {
            return -1;
        } else if (a.antragsdatum < b.antragsdatum) {
            return 1;
        } else {
            return 0;
        }
    }
}
